export default "__VITE_ASSET__2u_MNf9L__"